import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-square-sharp",
  "use": "icon-square-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-square-sharp\"><title>Square</title><path d=\"M48 48h416v416H48z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol